import React from 'react'
import { EmptyScreen } from 'modules/core/components'

// TODO: Notificar
const ScreenSuccess = ({ image, title, description, footer }) => {
  return <EmptyScreen image={image} title={title} description={description} footer={footer} />
}

export default ScreenSuccess
